import { useSelector } from 'react-redux';

import { AddOns } from '../../../../../constants/add-ons';
import { US } from '../../../../../constants/country-codes';
import Global from '../../../../../store/global-selectors';

/** @typedef {import('../../../../../constants/add-on-code').AddOnCode} AddOnCode */

/**
 * @typedef {object} AddOn
 * @property {AddOnCode} code
 */

export const useShouldShowAuctaneNetworkBanner = () => {
  const sellerHomeCountry = useSelector(Global.selectSellerHomeCountry);
  const isUsSeller = sellerHomeCountry === US;

  /** @type {{ marketplaceAddOns: AddOn[]}} */
  const { marketplaceAddOns = [] } = useSelector(Global.selectSellerSubscriptionPlanInfo) || {};

  const canPurchaseAddOnForAuctaneNetwork = marketplaceAddOns.some(
    (addOn) => addOn.code === AddOns.DropShip || addOn.code === AddOns.FulfillmentProviderBundle,
  );

  return isUsSeller && canPurchaseAddOnForAuctaneNetwork;
};
